export { default as companyFragment } from './company-fragment';
export { default as createOneCompanyMutation } from './create-one-company-mutation';
export { default as findByIdCompanyQuery } from './find-by-id-company-query';
export { default as findManyCompanyQuery } from './find-many-company-query';
export { default as removeByIdCompanyMutation } from './remove-by-id-company-mutation';
export { default as updateByIdCompanyMutation } from './update-by-id-company-mutation';
